// extracted by mini-css-extract-plugin
export var fallback = "_g-0";
export var icon = "_g-1";